module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[107]350.16f5d2f.woff2";